export enum WeddingCakeSize {
	Portions12 = "Portions12",
	Portions18 = "Portions18",
	Portions25 = "Portions25",
	Portions30 = "Portions30",
	Portions40 = "Portions40",
	Portions50Double = "Portions50Double",
	Portions50Triple = "Portions50Triple",
	Portions60 = "Portions60",
	Portions70 = "Portions70",
	Portions80 = "Portions80",
	Portions90 = "Portions90",
	Portions90Plus = "Portions90Plus",
}
